import React, { Component } from 'react';
import _ from 'lodash';
import { Form } from 'antd';
import PropertySheet from "./PropertySheet";
import PropertyGridItem from "./PropertyGridItem";
import PropertyGridUtils from "./PropertyGridUtils";

export default class PropertyLayout extends Component {

    constructor(props, context) {
        super(props, context);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.catalogs !== this.props.catalogs;
    }

    renderEditor(property) {

        const getter = PropertyGridUtils.getEditor(property);
        return (
            <PropertyGridItem key={property.name} source={property}>
                {getter(property, this.props.propertyGrid)}
            </PropertyGridItem>
        );
    }

    render() {

        // const { form } = Form.useForm();

        // const formItemLayout = {
        //     labelCol: {
        //         xs: { span: 24 },
        //         sm: { span: 9 },
        //     },
        //     wrapperCol: {
        //         xs: { span: 24 },
        //         sm: { span: 15 },
        //     },
        // };

        return (
            <div className={"propertygrid propertygrid-layout fill layout-v vstretch vscroll" + (this.props.className || "")}  >
                {
                    this.props.catalogs.map(c => {

                        if (c.items.length === 1 && c.items[0].type === "propertygrid") {
                            return this.renderEditor(c.items[0]);
                        }
                        else {
                            return <PropertySheet propertyGrid={this.props.propertyGrid} key={c.name} source={c} layout={this.props.formItemLayout} showDescription={this.props.showDescription} orient={this.props.orient} />;
                        }
                    })
                }
            </div>
        );
    }
}